import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import Transactable from 'shared-components/flow-transactable/transactable-main';
import { get } from 'lodash';
import { fetchTransactStatus, updateProfile200 } from '../actions/auth';
import IntlProviderHOC from '../../app-main/containers/IntlProviderHOC';

const TransactatableHOC = (Component) => {
  class Container extends React.Component {
    constructor (props) {
      super(props);

      this.state = {
        displayComponent: false,
        modalClosed: false
      };
      this.redirector = null;
      this.closeBehavior = this.closeBehavior.bind(this);
    }

    componentDidUpdate (prevProps) {
      const { profile = {} } = this.props;
      const prevProfile = get(prevProps, 'profile', {});

      if (prevProfile.isFetching && !profile.isFetching) {
        ReactDOM.render(
          <IntlProviderHOC>
            <Transactable
              user={profile.data}
              intendedAction={() => this.setState({ displayComponent: true })}
              closeBehavior={this.closeBehavior}
            />
          </IntlProviderHOC>,
          document.getElementById('modal-container')
        );
      }
    }

    closeBehavior () {
      const { auth, profile, dispatch } = this.props;

      // for some reason closeBehavior is being called twice (back to back) from modal.jsx
      // this conditional prevents the call from being called twice
      if (!profile.transactFetching) {
        return dispatch(fetchTransactStatus(profile.SSOid, auth.accessToken))
          .then((response) => {
            const isTransactable = get(response, 'ready_to_transact', false);
            const newProfile = get(response, 'profile', {});

            if (isTransactable) {
              dispatch(updateProfile200(newProfile));
              return this.setState({ displayComponent: true });
            }

            window.location.href = '/';
          });
      }
    }

    render () {
      return (
        <div>
          {
            this.state.displayComponent &&
            <Component {...this.props} />
          }
        </div>
      );
    }
  }

  Container.propTypes = {
    auth: PropTypes.object,
    dispatch: PropTypes.func,
    profile: PropTypes.object,
    location: PropTypes.object.isRequired
  };

  const mapStateToProps = (state) => ({
    auth: state.auth,
    profile: state.profile
  });

  return connect(mapStateToProps)(Container);
};

export default TransactatableHOC;
